import { Box, SelectChangeEvent } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import EraserIcon from "../../../../../assets/VideoEditing/icons/EraserIcon";
import IncreaseResIcon from "../../../../../assets/VideoEditing/icons/IncreaseResIcon";
import RmbgIcon from "../../../../../assets/VideoEditing/icons/RmbgIcon";
import SolidBgIcon from "../../../../../assets/VideoEditing/icons/SolidBgIcon";
import { EditIcon2 } from "../../../../../assets/images/icons/EditIcon2";
import BriaDropDown, { DropDownItem } from "../../../../../components/common/BriaDropDown/BriaDropDown";
import { useAppStore } from "../../../../../hooks/useStores";
import { VideoEditingTools } from "../../../../../models/video-editing";
import VideoEraserConfig from "../Eraser/VideoEraserConfig";
import VideoIncreaseResConfig from "../IncreaseRes/VideoIncreaseResConfig";
import VideoRemoveBackgroundConfig from "../RemoveBackground/VideoRemoveBackgroundConfig";
import VideoSolidBackgroundConfig from "../SolidBackground/VideoSolidBackgroundConfig";
import styles from "./VideoEditingToolsDropdown.module.scss";

const VideoEditingToolsDropdown = () => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.config.tools" });
	const { videoEditingStore } = useAppStore();

	const handleToolChange = async (e: SelectChangeEvent<VideoEditingTools>) => {
		const selectedTool = e.target.value as VideoEditingTools;
		videoEditingStore.handleConfigChange("tool", selectedTool);
	};

	const videoEditingTools: DropDownItem<VideoEditingTools>[] = [
		{
			key: t("erase.label"),
			value: "erase",
			icon: <EraserIcon className={styles.icon} />,
		},
		{
			key: t("remove_background.label"),
			value: "remove_background",
			icon: <RmbgIcon className={styles.icon} />,
		},
		{
			key: t("solid_background.label"),
			value: "solid_background",
			icon: <SolidBgIcon className={styles.icon} />,
		},
		{
			key: t("increase_resolution.label"),
			value: "increase_resolution",
			icon: <IncreaseResIcon className={styles.icon} />,
		},
	];

	const ToolConfigComponent = useMemo(() => {
		switch (videoEditingStore.config?.tool) {
			case "erase":
				return <VideoEraserConfig />;
			case "remove_background":
				return <VideoRemoveBackgroundConfig />;
			case "solid_background":
				return <VideoSolidBackgroundConfig />;
			case "increase_resolution":
				return <VideoIncreaseResConfig />;
			default:
				return <></>;
		}
	}, [videoEditingStore.config?.tool]);

	return (
		<Box className={styles.dropdownContainer}>
			<BriaDropDown<VideoEditingTools>
				value={videoEditingStore.config.tool}
				items={videoEditingTools}
				onChange={handleToolChange}
				placeholder={t("placeholder")}
				icon={<EditIcon2 className={styles.icon} />}
				componentsProps={{
					root: { className: styles.dropdownButton },
				}}
				height="48px"
				width="100%"
			/>
			{ToolConfigComponent}
		</Box>
	);
};

export default observer(VideoEditingToolsDropdown);
